import { render, staticRenderFns } from "./OrgTree.vue?vue&type=template&id=5e83442c"
import script from "./OrgTree.vue?vue&type=script&lang=js"
export * from "./OrgTree.vue?vue&type=script&lang=js"
import style0 from "./OrgTree.vue?vue&type=style&index=0&id=5e83442c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports